












import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IMenuRoute } from "@/models/routes";

@Component
export default class AdminClientSettingsView extends Vue {
  // Props

  @Prop({ default: () => [] })
  public routes!: () => IMenuRoute[];
}
